// src/store/index.ts
import { createStore } from 'vuex';
import axios from 'axios';

export default createStore({
  state: {
    token: localStorage.getItem('token') || ''
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    }
  },
  actions: {
    async exchangeToken({ commit }, { code }) {
      try {
        // 发起 POST 请求，传递 code 作为查询参数
        const response = await axios.post('/zwai/api/wechat/auth', null, {
            params: {
                code: code
            },
            headers: {
              Authorization: "Pass"
            }
        });
        
        // 获取返回的 token
        const token = response.data;

        // 提交 token 到 Vuex
        commit('setToken', token);
    } catch (error) {
        console.error('Error during authentication:', error);
        throw new Error('Network response was not ok');
    }
      
    },
    async checkToken({ commit }, token) {

        try{
            const response = await axios.post('/zwai//api/wechat/check', null,{ 
                params: {
                    token: token
                },
                headers: {
                  Authorization: token
                }
            });
            if (response.data) {
                return true;
            } else {
                commit('setToken', '');
                localStorage.removeItem('token');
                return false;
            }
        }catch (error) {
            console.error('Error during check:', error);
            throw new Error('Network response was not ok');
        }

    }




  }
});
